// SPDX-FileCopyrightText: 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2025 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export const projectOrderOptions = [
  {key: 'impact_cnt', label: 'Impact', direction:'desc.nullslast'},
  {key: 'output_cnt', label: 'Output', direction: 'desc.nullslast'},
  {key: 'date_start', label: 'Start date', direction: 'desc.nullslast'},
  {key: 'date_end', label: 'End date', direction: 'asc.nullslast'},
  {key: 'title', label: 'Title', direction: 'asc.nullslast'}
]
